import { Box, CircularProgress, Typography, useTheme } from '@material-ui/core';
import { TranslatedTextV2 } from 'components/atoms/TranslatedText';
import _ from 'lodash';
import { useDispatch } from 'react-redux';
import {
  ITabContentProps,
  PropertyFilterType,
  TitleDeedOptions,
} from '../configuration';
import ProductFilterActions from '../store/actions';
import React from 'react';
import SelectField from './SelectField';
import * as ProductFilterSelectors from '../store/selectors';
import { useSelectLanguageID } from 'redux/reducers/gl_translations_reducer/selectors';
import { StateStatus } from 'redux/utils/common';

const TabVAT = (props: ITabContentProps) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const segments = ProductFilterSelectors.useGetSegments();
  const optionVAT = segments?.data?.tax?.options ?? [];
  const language = useSelectLanguageID();
  React.useEffect(() => {
    if (!segments.data) {
      dispatch(
        ProductFilterActions.fetchSegmentsAction({ language: language })
      );
    }
  }, [dispatch]);
  const isChecked = (currentKey: string) => {
    var isChecked = false;
    for (let key of Object.keys(props.selections.VAT.data))
      if (key !== currentKey)
        isChecked = isChecked || _.get(props.selections.VAT.data, key, null);
    return isChecked;
  };
  const onValueChange = (key: string, value: string | number | null) => {
    if (value === 'null') value = null;
    dispatch(
      ProductFilterActions.setFiltersSelectionAction({
        ...props.selections,
        [PropertyFilterType.VAT]: {
          ...props.selections[PropertyFilterType.VAT],
          ...(isChecked(key) || value
            ? { isChecked: true }
            : { isChecked: false }),
          data: {
            ...props.selections[PropertyFilterType.VAT].data,
            [key]: value,
          },
        },
      })
    );
  };
  return (
    <Box
      style={{
        position: 'relative',
      }}
    >
      <Typography
        style={{
          fontWeight: 700,
          fontSize: '16px',
          lineHeight: '20px',
          marginBottom: '4px',
        }}
      >
        <TranslatedTextV2 translationKey={`vat`} defaultText="VAT" />
      </Typography>
      <Typography
        style={{
          fontWeight: 400,
          fontSize: '12px',
          lineHeight: '16px',
          color: theme.palette.text.secondary,
          marginBottom: '18px',
        }}
      >
        <TranslatedTextV2 translationKey={''} defaultText={'Select one'} />
      </Typography>
      <SelectField
        label={{ translationKey: '', defaultText: ' ' }}
        options={optionVAT.map((item) => ({ id: item.id, label: item.name }))}
        onValueChange={onValueChange}
        field={'vat_options'}
        value={props.selections[PropertyFilterType.VAT].data.vat_options}
      />
      {segments.status === StateStatus.Pending ? (
        <Box
          style={{
            display: 'flex',
            position: 'absolute',
            right: '50%',
          }}
        >
          <CircularProgress />
        </Box>
      ) : null}
    </Box>
  );
};

export default TabVAT;
